"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTypographyHeadlineL = void 0;
require("./Text_typography_headline-l.css");
var core_1 = require("@bem-react/core");
var Text_1 = require("../Text");
/**
 * Модификатор, отвечающий за типографику текста.
 * @param {ITextTypographyHeadlineLProps} props
 */
exports.withTypographyHeadlineL = core_1.withBemMod(Text_1.cnText(), { typography: 'headline-l' });
